import React from 'react';
import styled from 'styled-components';
import { Spin as AntdSpin } from 'antd';
import { SpinProps as AntdSpinProps } from 'antd/lib/spin';
import { Icon } from '../Icon';
import { ColorNameType } from '../theme';

const sizeMap = {
  small: 18,
  large: 40,
  default: 22,
};

export type SpinProps = AntdSpinProps & {
  center?: boolean;
  showBackdrop?: boolean;
  position?: 'absolute' | 'relative';
  color?: ColorNameType;
};

/** @deprecated use Spin from bb/elements-web instead */
export const Spin: React.FC<SpinProps> = ({
  size = 'default',
  center,
  showBackdrop,
  position = 'relative',
  color = 'primary',
  className,
  ...props
}) => (
  <StyledWrapper
    $center={center}
    $size={size}
    $showBackdrop={showBackdrop}
    $position={position}
    className={className}
  >
    <AntdSpin
      {...props}
      indicator={
        <Icon
          type="antdLoadingOutlined"
          width={sizeMap[size]}
          color={color}
          offset={[0, -2]}
        />
      }
    />
  </StyledWrapper>
);

const StyledWrapper = styled.span<{
  $center?: boolean;
  $size?: SpinProps['size'];
  $showBackdrop?: boolean;
  $position: SpinProps['position'];
}>`
  ${({ $center }) =>
    $center &&
    `
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  `}
  ${({ $position }) => `position: ${$position}`};
  ${({ $size }) => `
    > * {
      margin-left: -${sizeMap[$size] / 2}px;
    }
  `}
  ${({ $showBackdrop }) =>
    $showBackdrop &&
    `
  background-color: #5e5e5e9e;
`}
`;

/** @deprecated import Spin from bb/elements-web instead */
export default styled(Spin)``;
